import useRpc, { refreshRpc } from './useRpc'
import rpc, { rpcTask } from './rpc'


export function useWebsiteScanners() {
  return useRpc('websiteScanner.list')
}


export async function addWebsiteScanner(url) {
  return rpcTask('websiteScanner.add', { url })
}


export async function deleteWebsiteScanner(id) {
  await rpc('websiteScanner.delete', { id }, { throwErrors: true })
  await refreshRpc('websiteScanner.list')
  await refreshRpc('topics.all')
}


export async function refreshWebsiteScanners() {
  await refreshRpc('websiteScanner.list')
  await refreshRpc('topics.all')
}
